<template>
  <div class="text-overflow" :style="{'width': width}" ref="el" :title="overflowTitle">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'o-text-preview',

  data: () => ({
    overflowTitle: ''
  }),

  props: {
    width: {
      type: String,
      default: '100px'
    }
  },

  mounted() {
    this.overflowTitle = this.$refs.el.innerText
  }
}
</script>

<style scoped>
.text-overflow {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
